import { animated, useSpring } from 'react-spring';
import React from 'react';

export interface AdminSiteViewportShifterProps
  extends React.HTMLAttributes<HTMLDivElement> {
  shiftDown?: boolean;
}

export const AdminSiteViewportShifter: React.FunctionComponent<
  AdminSiteViewportShifterProps
> = (props): React.ReactElement => {
  const { children, style, shiftDown, ...rest } = props;

  const { transform } = useSpring({
    to: { transform: shiftDown ? 2.5 : 0 },
  }) as any;

  return (
    <animated.div
      style={{
        ...props.style,
        transform: transform.interpolate((v: number): string =>
          v === 0 ? '' : `translateY(${v}rem)`,
        ),
      }}
      {...rest}
    >
      {children}
    </animated.div>
  );
};

AdminSiteViewportShifter.displayName = 'AdminSiteViewportShifter';
